var _ellipse, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyFields = function SvgEmptyFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 51 48"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.469,
    cy: 23.988,
    fill: "#E4E7EC",
    rx: 25,
    ry: 23.988
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m13.871 32.287 15.469 15.38c9.274-1.393 16.854-7.584 19.838-15.94L36.832 18.313l-1.426.76-.662-.001h-1.595l-17.438.758v3.359l4.982 3.357-4.982 4.116z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6.863,
    x: 13.734,
    y: 18,
    fill: "#fff",
    rx: 1.529
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.132,
    height: 3.432,
    x: 15.668,
    y: 19.715,
    fill: "#D4DAE1",
    rx: 0.765
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 6.863,
    x: 13.734,
    y: 25.863,
    fill: "#fff",
    rx: 1.529
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20.132,
    height: 3.432,
    x: 15.668,
    y: 27.578,
    fill: "#D4DAE1",
    rx: 0.765
  })));
};
export { SvgEmptyFields as ReactComponent };
export default __webpack_public_path__ + "fonts/empty-fields-7dd778795bda9ea81692d38dbe7eda58.svg";